import React from 'react';
import { Link } from 'react-router';
import { Card } from './Card';
import { Button } from './Button';
import { IconWrap } from './IconWrap';
import useTheme from '../hooks/useTheme';

interface EmptyStateProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    actions?: Array<{ label: string; path: string; variant?: 'primary' | 'secondary' }>;
    chips?: string[];
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    icon,
    title,
    description,
    actions = [],
    chips = [],
}) => {
    const { theme } = useTheme();

    return (
        <Card
            style={{
                textAlign: 'center',
                padding: '48px 32px',
                maxWidth: '600px',
                margin: '0 auto',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '24px',
                }}
            >
                <div
                    style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        backgroundColor: theme.background.panel,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `2px solid ${theme.colors.line}`,
                    }}
                >
                    <IconWrap icon={icon} size={40} color="muted" />
                </div>
            </div>

            <h3
                style={{
                    fontSize: '22px',
                    fontWeight: 600,
                    color: theme.text.primary,
                    marginBottom: '12px',
                }}
            >
                {title}
            </h3>

            <p
                style={{
                    color: theme.text.muted,
                    lineHeight: 1.6,
                    marginBottom: '24px',
                }}
            >
                {description}
            </p>

            {chips.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        marginBottom: '32px',
                    }}
                >
                    {chips.map((chip, idx) => (
                        <span
                            key={idx}
                            style={{
                                padding: '6px 12px',
                                backgroundColor: theme.background.panel,
                                border: `1px solid ${theme.colors.line}`,
                                borderRadius: theme.borderRadius.r1,
                                fontSize: '13px',
                                color: theme.text.muted,
                            }}
                        >
                            {chip}
                        </span>
                    ))}
                </div>
            )}

            {actions.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    {actions.map((action, idx) => (
                        <Link key={idx} to={action.path} style={{ textDecoration: 'none' }}>
                            <Button variant={action.variant || 'secondary'}>{action.label}</Button>
                        </Link>
                    ))}
                </div>
            )}
        </Card>
    );
};

